<template>
  <div>
    <div class="center spinner" :style="{display: display ? 'block' : 'none'}">
      <div class="loading">
        <img src="/img/loading.gif" />
        <span class="text"> Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
</style>
